module.exports = __webpack_public_path__ + "img/25761bad-f73c-436d-bc07-670cf37d7270.018.7bf6f270.png";